import availableJobCategories from '@/helpers/availableJobCategoriesHelper'

export default function() {
    return {
        availableJobCategories,
        symplaEvent: {
            categories: [],
            symplaId: '',
            badge: ''
        },
        symplaTokens: [],
        success: false,
        customToolbar: [["bold", "italic", "underline"], [{ list: "ordered" }, { list: "bullet" }], ["image"]],
        errors: {
            symplaId: null,
            token: null
        }
    }
}
